import React from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const LogOutContentBottom = () => {
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem("acc_data");
        localStorage.removeItem("jwt_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("lgnSrc");
        localStorage.removeItem("guest_acc_data");
        navigate("");
        window.location.reload();
    };
    return (React.createElement(Col, { lg: 12, className: "support-genericSidebar" },
        React.createElement("div", { className: "support-content-body mb-15" },
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("span", { className: "edel-icon-service icon" },
                        React.createElement("span", { className: "path1" }),
                        React.createElement("span", { className: "path2" }),
                        React.createElement("span", { className: "path3" }),
                        React.createElement("span", { className: "path4" }),
                        React.createElement("span", { className: "path5" }),
                        React.createElement("span", { className: "path6" })),
                    React.createElement("span", { className: "txt-hover" }, "Service Request")),
                React.createElement("li", null,
                    React.createElement("span", { className: "edel-icon-logout1 icon" },
                        React.createElement("span", { className: "path1" }),
                        React.createElement("span", { className: "path2" })),
                    React.createElement("span", { onClick: logout, className: "txt_bloodRed" }, "Logout"))))));
};
export default LogOutContentBottom;
